import {
  makeAddressArraySync,
  makeAddressSync,
  ProtocolConfig,
} from "@silo/types";
import { satisfies } from "effect/Function";
import { TOKEN_ADDRESS } from "../token-address";
import { MARKET_ADDRESS } from "../market-address";

export const mainnetGrand = satisfies<ProtocolConfig>()({
  firstBridgeSymbol: "ETH",
  secondBridgeSymbol: "USDC",
  marketWhitelist: new Set([
    MARKET_ADDRESS.mainnetGrand.PT_weETH_26SEP2024,
    MARKET_ADDRESS.mainnetGrand.PT_pufETH_26SEP2024,
    MARKET_ADDRESS.mainnetGrand.PT_weETH_DEC2024,
    MARKET_ADDRESS.mainnetGrand.PT_rsETH_DEC2024,
    MARKET_ADDRESS.mainnetGrand.PT_pufETH_DEC20204,
  ]),
  pinnedMarkets: [],
  markets: {
    [MARKET_ADDRESS.mainnetGrand.PT_ezETH_26SEP2024]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetGrand.PT_weETH_26SEP2024]: {
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetGrand.PT_weETH_DEC2024]: {
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetGrand.PT_sUSDE_26SEP2024]: {
      depositMode: {
        base: "protectedOnly",
      },
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetGrand.PT_pufETH_26SEP2024]: {
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetGrand.PT_pufETH_DEC20204]: {
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetGrand.PT_rsETH_DEC2024]: {
      depositMode: {
        base: "protectedOnly",
      },
    },
    [MARKET_ADDRESS.mainnetGrand.amphrETH]: {
      points: {
        base: {
          collateral: [
            { _tag: "mellow", label: "2x Mellow" },
            { _tag: "symbiotic", label: "1x Symbiotic" },
          ],
        },
        firstBridge: {
          collateral: [{ _tag: "turtle" }],
        },
      },
    },
    [MARKET_ADDRESS.mainnetGrand.re7LRT]: {
      points: {
        base: {
          collateral: [
            { _tag: "mellow", label: "2x Mellow" },
            { _tag: "symbiotic", label: "1x Symbiotic" },
          ],
        },
        firstBridge: {
          collateral: [{ _tag: "turtle" }],
        },
      },
    },
    [MARKET_ADDRESS.mainnetGrand.pzETH]: {
      points: {
        base: {
          collateral: [
            { _tag: "mellow", label: "2x Mellow" },
            { _tag: "symbiotic", label: "1x Symbiotic" },
            { _tag: "renzo", label: "2x Renzo" },
          ],
        },
        firstBridge: {
          collateral: [{ _tag: "turtle" }],
        },
      },
    },
    [MARKET_ADDRESS.mainnetGrand.ezETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetGrand.weETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetGrand.rstETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetGrand.pzETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetGrand.amphrETH]: {
      labelAsDeprecated: true,
    },
    [MARKET_ADDRESS.mainnetGrand.re7LRT]: {
      labelAsDeprecated: true,
    },
  },
  nativeRewards: {
    siloIncentivesControllerAddress: makeAddressSync(
      "0xB14F20982F2d1E5933362f5A796736D9ffa220E4"
    ),
    tokenAddress: TOKEN_ADDRESS.ethereum.SILO,
    symbol: "SILO",
    decimals: 18,
    historicalShareTokens: {
      [TOKEN_ADDRESS.ethereum.SILO]: makeAddressArraySync([
        //spzETH
        "0x18A9c82C4aE9e121B7c6E33bb1CFBA029bd2e0F2",
        //sETH-pzETH
        "0x45758dA27E6bbBF58b7C500B19f4745Cc3B43686",
        //sUSDC-pzETH
        "0x1a4833aC0d2c5980f5bce65d6f306eC38c6a13B0",
        //spamphrETH
        "0xc3eA158aCffef5b5e6289cdd34f24DAb04308B51",
        //sETH-amphrETH
        "0xdf683738D57496E08f77bD2a551BEa782d03b077",
        //sUSDC-amphrETH
        "0xC97Cb442f4733A903efBE97e616aa1a605089Be7",
        //sprstETH
        "0xEC5eE1D010f9Fc8A2EFBdB5056f72e4c9a6Fc0D2",
        //sETH-rstETH
        "0x309fB48ab256e95BB9EA46Bff339b559Aa613182",
        //sUSDC-rstETH
        "0x44Dd9bbebe8C8fF97d62245552A5Ca1226F897C0",
        //spRe7LRT
        "0xa2d2dDB54fc7b6af4A4274DcD4BeC1269E96B353",
        //sETH-Re7LRT
        "0x6C9956f7BD0873fa9e7cE1e79D076a8b8051488A",
        //sUSDC-Re7LRT
        "0x1BfEc21712e47Ee9aef609518f2128875e0734b1",
        //spPT-weETH
        "0xF7140B0500d0EFf3C7091881749b0829962e53eb",
        //sETH-PT-weET
        "0xa13f11D61912773E98921aB6E4cbD0a885EE77D7",
        //sUSDC-PT-weETH
        "0x7f3dCC5455dE53EE57bd0dF8A0e1c3012e412937",
        //spPT-rsETH
        "0xdB154f56fC6dd2a45dcd2EDcF8e7D9C1E2E42AFc",
        //sETH-PT-rsETH
        "0x957DFca0a232907b905A9002dEBb9d2E9867b8D0",
        //sUSDC-PT-rsETH
        "0x6B7477F716bcb689F104A2f4C609E41c26F3b5E5",
        //spPT-pufETH
        "0x2be0182BEb6db51002003f2c9831b7F5a829cFa0",
        //sETH-PT-pufETH
        "0x019b1099aa58B6De74dfbD98d7A5c4C3c771E938",
        //sUSDC-PT-pufETH
        "0xd17Be6a2573F085109bF1f1C85567111e09b364e",
      ]),
    },
  },
} as const);
